import styled from 'styled-components';

import {FormControl, FormHelperText, Input, Stack, useToast} from "@chakra-ui/react";
import {useEffect, useState} from "react";
import {WhiteMain} from "../../../components/main";
import {FixedTopBar} from "../../../components/top_bar";
import useFeedback from "../../../utils/use_feedback";
import FormContainer from "../../../components/form_container";
import {useSaveClicked} from "../../../store";
import {useDeleteAccount} from "../../../api/delete_account";

const SwitchHeading = styled.div``;

const DeleteSettings = styled(({className}) => {

    const {error, busy, feedbackCh} = useFeedback();
    const [credentials, setCredentials] = useState({
        currentPassword: '',
    });
    const set = (name) => (value) => setCredentials((credentials) => ({...credentials, [name]: value}));
    const setDeleteAccount = useDeleteAccount(feedbackCh);

    const saveClicked = useSaveClicked();
    const [saving, setSaving] = useState(false);
    const toast = useToast();
    useEffect(() => {
        (async () => {
            if (saveClicked) {
                if (!saving) {
                    try {
                        await setDeleteAccount(credentials.currentPassword);
                        toast({
                            title: "Account deleted.",
                            status: 'success',
                            isClosable: true,
                        });
                    } catch {
                        toast({
                            title: "An error occured - incorrect password?",
                            status: 'error',
                            isClosable: true,
                        });
                    }
                }
            }
        })().then(() => {}, () => {});
    }, [saveClicked]);

    return (
        <>
            <FixedTopBar back title="Delete Account" border={false} save/>
            <WhiteMain className={className}>
                <FormContainer>

                    <p style={{fontSize: 15,  marginBottom: '8px'}}>
                        This option will wipe all sensitive information and remove all of your posts, comments, messages, and edit revisions from our database immediately.
                    </p>

                    <Stack spacing={5}>

                        <FormControl>
                            <SwitchHeading>Confirm Password</SwitchHeading>
                            <Input type="password"
                                   maxLength="64"
                                   autoComplete="off"
                                   placeholder={'********'}
                                   required
                                   value={credentials.currentPassword}
                                   onChange={(e) => set('currentPassword')(e.currentTarget.value)} />
                            <FormHelperText>Required for security reasons.</FormHelperText>
                        </FormControl>

                    </Stack>

                </FormContainer>
            </WhiteMain>
        </>
    );
})`
  ${FormContainer} {
    background-color: ${({theme}) => theme.color.name === 'dark' ? 'transparent' : theme.white_0};
    padding: 16px 20px;
  }
  ${SwitchHeading} {
    font-weight: 600;
    font-size: 14px;
    padding: 6px 0;
  }
`;

export default DeleteSettings;
